import React from "react";
import IndustryAdvertisementEntries from "../../../Administrative/IndustryAdvertisementEntries";

const AvertisementsFromIndustry = () => {
  return (
    <div>
      <IndustryAdvertisementEntries />
    </div>
  );
};

export default AvertisementsFromIndustry;
